/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Panel = (props: any) => (
<svg {...props}   viewBox="0 0 21 20" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 2544">
<path id="Union" fillRule="evenodd" clipRule="evenodd" d="M16 4C16 5.10457 15.1046 6 14 6C12.8954 6 12 5.10457 12 4C12 2.89543 12.8954 2 14 2C15.1046 2 16 2.89543 16 4ZM10.126 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H10.126C10.5701 6.72523 12.1362 8 14 8C15.8666 8 17.4346 6.72147 17.8759 4.99237C17.9166 4.99741 17.958 5 18 5H20C20.5523 5 21 4.55228 21 4C21 3.44772 20.5523 3 20 3H18C17.958 3 17.9166 3.00259 17.8759 3.00763C17.4346 1.27853 15.8666 0 14 0C12.1362 0 10.5701 1.27477 10.126 3Z" fill="#282828"/>
<path id="Union_2" fillRule="evenodd" clipRule="evenodd" d="M9 16C9 17.1046 8.10457 18 7 18C5.89543 18 5 17.1046 5 16C5 14.8954 5.89543 14 7 14C8.10457 14 9 14.8954 9 16ZM10.874 15C10.4299 13.2748 8.86384 12 7 12C5.13616 12 3.57006 13.2748 3.12602 15H1C0.447715 15 0 15.4477 0 16C0 16.5523 0.447715 17 1 17H3.12602C3.57006 18.7252 5.13616 20 7 20C8.86384 20 10.4299 18.7252 10.874 17H20C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15H10.874Z" fill="#282828"/>
</g>
</svg>
);

export default Panel;